'use client';

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import MultiCarouselAlsoLike from './MultiCarouselAlsoLike';
import classes from './AlsoLike.module.css';
import { newFilters } from '@/utils/newFilters';

const algoliarecommend = require('@algolia/recommend');

const recommendClient =
	process.env.NEXT_PUBLIC_OG_DB === 'true'
		? algoliarecommend(
				process.env.NEXT_PUBLIC_ALGOLIA_APPID,
				process.env.NEXT_PUBLIC_ALGOLIA_API_KEY
		  )
		: algoliarecommend(
				process.env.NEXT_PUBLIC_DUMMY_ALGOLIA_APPID,
				process.env.NEXT_PUBLIC_DUMMY_ALGOLIA_API_KEY
		  );

const AlsoLike = (props) => {
	const { listing, deviceWidth } = props;

	const [similarItems, setSimilarItems] = useState([]);

	const getRecommendedAlgoliaListingsHandler = async (listingId) => {
		let facetFilter;
		if (listing.newSchema.types && listing.newSchema.types[0]) {
			// Use type if available
			facetFilter = `newSchema.types:${listing.newSchema.types[0]}`;
		} else if (
			listing.newSchema.subCategories &&
			listing.newSchema.subCategories[0]
		) {
			// Fallback to subCategory if type is not available
			facetFilter = `newSchema.subCategories:${listing.newSchema.subCategories[0]}`;
		} else {
			// Handle case where neither is available
			console.error('No suitable filter available.');
			return;
		}

		recommendClient
			.getRelatedProducts([
				{
					indexName: 'kashew_listings',
					objectID: listingId,
					maxRecommendations: 15,
					queryParameters: {
						facetFilters: [facetFilter], // Apply dynamic facet filter
					},
				},
			])
			.then(({ results }) => {
				setSimilarItems(results[0].hits); // filtering out the current item
			})
			.catch((err) => {
				console.log(err);
			});
	};

	useEffect(() => {
		if (listing && listing._id) {
			getRecommendedAlgoliaListingsHandler(listing._id);
		}
	}, [listing]);

	const router = useRouter();

	function findCategoryHierarchy(listing, newFilters) {
		let matchedCategory = null;
		let matchedSubCategory = null;

		if (
			listing.newSchema.types &&
			listing.newSchema.types[0] &&
			listing.newSchema.types[0] !== 'None' &&
			listing.newSchema.types[0] !== null
		) {
			newFilters.categories.forEach((category) => {
				category.subCategories.forEach((subCategory) => {
					subCategory.types?.forEach((type) => {
						if (type.name === listing.newSchema.types[0]) {
							matchedCategory = category.category;
							matchedSubCategory = subCategory.name;
						}
					});
				});
			});
		}

		if (
			!matchedCategory &&
			listing.newSchema.subCategories &&
			listing.newSchema.subCategories[0]
		) {
			const firstSubCategoryName = listing.newSchema.subCategories[0];
			newFilters.categories.forEach((category) => {
				category.subCategories.forEach((subCategory) => {
					if (subCategory.name === firstSubCategoryName) {
						matchedCategory = category.category;
						matchedSubCategory = subCategory.name;
					}
				});
			});
		}

		return matchedCategory && matchedSubCategory
			? {
					category: matchedCategory,
					subCategory: matchedSubCategory,
					type:
						matchedCategory && matchedSubCategory
							? listing.newSchema.types[0]
							: null,
			  }
			: null;
	}

	const matchedHierarchy = findCategoryHierarchy(listing, newFilters);

	const seeAllHandler = () => {
		if (matchedHierarchy.type) {
			router.push(
				`/collections/${matchedHierarchy.category
					.replace(/ /g, '-')
					.replace(/&/g, 'and')
					.toLowerCase()}/${matchedHierarchy.subCategory
					.replace(/ /g, '-')
					.replace(/&/g, 'and')
					.toLowerCase()}/${matchedHierarchy.type
					.replace(/ /g, '-')
					.replace(/&/g, 'and')
					.toLowerCase()}`
			);
		} else {
			router.push(
				`/collections/${matchedHierarchy.category
					.replace(/ /g, '-')
					.replace(/&/g, 'and')
					.toLowerCase()}/${matchedHierarchy.subCategory
					.replace(/ /g, '-')
					.replace(/&/g, 'and')
					.toLowerCase()}`
			);
		}
	};

	return (
		<>
			{similarItems && similarItems.length > 0 && (
				<div className={classes.similarItems}>
					<div className={classes.headerBox}>
						<h6 className={classes.header}>
							Similar{' '}
							{listing.newSchema.types[0]
								? listing.newSchema.types[0]
								: listing.newSchema.subCategories[0]}
						</h6>
						<button onClick={() => seeAllHandler()} className={classes.seeAll}>
							See all
						</button>
					</div>
					<MultiCarouselAlsoLike
						listings={similarItems}
						deviceWidth={deviceWidth}
					/>
				</div>
			)}
		</>
	);
};
export default AlsoLike;
